export default "__VITE_ASSET__CRgRkAyn__"